var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0" },
    [
      _c("v-text-field", {
        staticClass: "mb-4",
        attrs: {
          label: "Arbeitsdatum",
          type: "date",
          dense: "",
          outlined: "",
          "hide-details": "",
          readonly: _vm.readonly,
          "prepend-inner-icon": "mdi-calendar"
        },
        model: {
          value: _vm.selectedDate,
          callback: function($$v) {
            _vm.selectedDate = $$v
          },
          expression: "selectedDate"
        }
      }),
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c("v-textarea", {
            attrs: {
              label: "Bemerkungen",
              readonly: true,
              outlined: "",
              dense: "",
              rows: "3",
              "auto-grow": ""
            },
            model: {
              value: _vm.values.comments,
              callback: function($$v) {
                _vm.$set(_vm.values, "comments", $$v)
              },
              expression: "values.comments"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex align-center mb-2" },
        [
          _c("div", { staticClass: "subtitle-1 font-weight-bold" }, [
            _vm._v("Zeiteintraege")
          ]),
          _vm.oldTimeEntriesCount > 0
            ? _c(
                "v-btn",
                {
                  staticClass: "ml-2",
                  attrs: {
                    icon: "",
                    small: "",
                    title: _vm.showOldTimeEntries
                      ? "Alte Eintraege ausblenden"
                      : "Alte Eintraege einblenden"
                  },
                  on: {
                    click: function($event) {
                      _vm.showOldTimeEntries = !_vm.showOldTimeEntries
                    }
                  }
                },
                [
                  _c(
                    "v-badge",
                    {
                      attrs: {
                        content: String(_vm.oldTimeEntriesCount),
                        color: "grey",
                        overlap: ""
                      }
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.showOldTimeEntries ? "mdi-eye" : "mdi-eye-off"
                            ) +
                            " "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._l(_vm.timeEntries, function(entry, i) {
        return _c(
          "v-card",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isTimeEntryCurrent(entry) || _vm.showOldTimeEntries,
                expression: "isTimeEntryCurrent(entry) || showOldTimeEntries"
              }
            ],
            key: "te" + i,
            class: [
              "mb-2 pa-2",
              { "old-entry": !_vm.isTimeEntryCurrent(entry) }
            ],
            attrs: { outlined: "" }
          },
          [
            _c(
              "v-row",
              { attrs: { dense: "" } },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "4", sm: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Pers.",
                        type: "number",
                        min: "1",
                        dense: "",
                        "hide-details": "",
                        outlined: "",
                        readonly: _vm.readonly || !_vm.isTimeEntryCurrent(entry)
                      },
                      model: {
                        value: entry.persons,
                        callback: function($$v) {
                          _vm.$set(entry, "persons", _vm._n($$v))
                        },
                        expression: "entry.persons"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "4", sm: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Arbeit",
                        type: "number",
                        step: "0.25",
                        min: "0",
                        dense: "",
                        "hide-details": "",
                        outlined: "",
                        readonly: _vm.readonly || !_vm.isTimeEntryCurrent(entry)
                      },
                      model: {
                        value: entry.work_hours_per_person,
                        callback: function($$v) {
                          _vm.$set(entry, "work_hours_per_person", _vm._n($$v))
                        },
                        expression: "entry.work_hours_per_person"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "4", sm: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Fahrt",
                        type: "number",
                        step: "0.25",
                        min: "0",
                        dense: "",
                        "hide-details": "",
                        outlined: "",
                        readonly: _vm.readonly || !_vm.isTimeEntryCurrent(entry)
                      },
                      model: {
                        value: entry.travel_hours_per_person,
                        callback: function($$v) {
                          _vm.$set(
                            entry,
                            "travel_hours_per_person",
                            _vm._n($$v)
                          )
                        },
                        expression: "entry.travel_hours_per_person"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex align-center caption grey--text mt-1" },
              [
                _c("span", [
                  _vm._v("= " + _vm._s(_vm.workTotal(entry)) + "h Arbeit")
                ]),
                _c("span", { staticClass: "mx-2" }, [_vm._v("|")]),
                _c("span", [
                  _vm._v(_vm._s(_vm.travelTotal(entry)) + "h Fahrt")
                ]),
                _c("v-spacer"),
                !_vm.readonly && _vm.isTimeEntryCurrent(entry)
                  ? _c(
                      "v-btn",
                      {
                        attrs: { icon: "", "x-small": "" },
                        on: {
                          click: function($event) {
                            return _vm.timeEntries.splice(i, 1)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("mdi-close")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      }),
      _vm.timeEntries.length
        ? _c(
            "div",
            { staticClass: "d-flex caption font-weight-bold mb-1 px-2" },
            [
              _c("span", [
                _vm._v("Summe: " + _vm._s(_vm.totalWorkHours) + "h Arbeit")
              ]),
              _c("v-spacer"),
              _c("span", [_vm._v(_vm._s(_vm.totalTravelHours) + "h Fahrt")])
            ],
            1
          )
        : _vm._e(),
      !_vm.readonly
        ? _c(
            "v-btn",
            {
              staticClass: "mt-2",
              attrs: { outlined: "", color: "primary" },
              on: { click: _vm.addTimeEntry }
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-plus")]),
              _vm._v(" Zeiteintrag ")
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.renderableArticles, function(item) {
        return [
          item.line_type === "title"
            ? _c(
                "div",
                {
                  key: "art" + item._idx,
                  staticClass:
                    "article-title pa-3 rounded subtitle-1 font-weight-bold mt-4 mb-1 d-flex align-center"
                },
                [
                  _c("span", { staticClass: "flex-grow-1" }, [
                    _vm._v(_vm._s(item.article_name))
                  ]),
                  item.article_description
                    ? _c(
                        "v-btn",
                        {
                          attrs: { icon: "", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.showDescription(
                                item.article_description
                              )
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-information-outline")
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "v-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        item._bomParent == null ||
                        _vm.bomExpanded[item._bomParent],
                      expression:
                        "item._bomParent == null || bomExpanded[item._bomParent]"
                    }
                  ],
                  key: "art" + item._idx,
                  class: [
                    item._isBomHead
                      ? "article-bom-head"
                      : item._bomParent != null
                      ? "article-bom-line ml-3"
                      : "article-item",
                    "mt-2 pa-3 rounded"
                  ],
                  attrs: { flat: "" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center flex-wrap" },
                    [
                      item._isBomHead
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mr-1",
                              attrs: { icon: "", small: "" },
                              on: {
                                click: function($event) {
                                  return _vm.$set(
                                    _vm.bomExpanded,
                                    item._idx,
                                    !_vm.bomExpanded[item._idx]
                                  )
                                }
                              }
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.bomExpanded[item._idx]
                                        ? "mdi-chevron-down"
                                        : "mdi-chevron-right"
                                    ) +
                                    " "
                                )
                              ])
                            ],
                            1
                          )
                        : _vm._e(),
                      item.article_description
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "mr-1",
                              attrs: { icon: "", small: "" },
                              on: {
                                click: function($event) {
                                  return _vm.showDescription(
                                    item.article_description
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: { small: "", color: "grey darken-1" }
                                },
                                [_vm._v(" mdi-information-outline ")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "span",
                        {
                          staticClass: "flex-grow-1",
                          class: item._isBomHead
                            ? "subtitle-2 font-weight-bold"
                            : "body-2"
                        },
                        [_vm._v(" " + _vm._s(item.article_name) + " ")]
                      ),
                      item.order_qty != null
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "caption grey--text text--darken-1 text-no-wrap ml-2"
                            },
                            [
                              _vm._v(" Best.: " + _vm._s(item.order_qty) + " "),
                              item.input_type === "time"
                                ? [
                                    _vm._v(
                                      " | Gel.: " +
                                        _vm._s(_vm.deliveredHours(item)) +
                                        " "
                                    )
                                  ]
                                : item.input_type === "article" &&
                                  item.line_type !== "title"
                                ? [
                                    _vm._v(
                                      " | Gel.: " +
                                        _vm._s(_vm.deliveredQty(item)) +
                                        " "
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  item.input_type === "time"
                    ? [
                        _vm.articles[item._idx].hours_grid &&
                        _vm.articles[item._idx].hours_grid.length
                          ? _c(
                              "div",
                              { staticClass: "grid-scroll mt-2" },
                              [
                                _c("v-simple-table", { attrs: { dense: "" } }, [
                                  _c("thead", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticStyle: { "min-width": "70px" }
                                        },
                                        [_vm._v("Pers.")]
                                      ),
                                      _c(
                                        "th",
                                        {
                                          staticStyle: { "min-width": "80px" }
                                        },
                                        [_vm._v("Stunden")]
                                      ),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "text-right",
                                          staticStyle: { "min-width": "60px" }
                                        },
                                        [_vm._v(" Ges. ")]
                                      ),
                                      !_vm.readonly
                                        ? _c("th", {
                                            staticStyle: { "min-width": "36px" }
                                          })
                                        : _vm._e()
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(
                                        _vm.articles[item._idx].hours_grid,
                                        function(row, ri) {
                                          return [
                                            !_vm.isCurrentDate(row.date) &&
                                            _vm.showOldGrid[item._idx] &&
                                            _vm.isFirstOfDate(
                                              _vm.articles[item._idx]
                                                .hours_grid,
                                              ri
                                            )
                                              ? _c(
                                                  "tr",
                                                  {
                                                    key: "hd" + ri,
                                                    staticClass: "old-entry"
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "caption font-weight-bold grey lighten-3 py-1",
                                                        attrs: {
                                                          colspan: _vm.readonly
                                                            ? 3
                                                            : 4
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                row.date
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "tr",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.isCurrentDate(
                                                        row.date
                                                      ) ||
                                                      _vm.showOldGrid[
                                                        item._idx
                                                      ],
                                                    expression:
                                                      "isCurrentDate(row.date) || showOldGrid[item._idx]"
                                                  }
                                                ],
                                                key: ri,
                                                class: {
                                                  "grey lighten-4":
                                                    row.hours_readonly ===
                                                    "true",
                                                  "old-entry": !_vm.isCurrentDate(
                                                    row.date
                                                  )
                                                }
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        type: "number",
                                                        min: "1",
                                                        dense: "",
                                                        "hide-details": "",
                                                        "single-line": "",
                                                        readonly:
                                                          _vm.readonly ||
                                                          row.hours_readonly ===
                                                            "true" ||
                                                          !_vm.isCurrentDate(
                                                            row.date
                                                          )
                                                      },
                                                      model: {
                                                        value: row.persons,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row,
                                                            "persons",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "row.persons"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        type: "number",
                                                        step: "0.25",
                                                        min: "0",
                                                        dense: "",
                                                        "hide-details": "",
                                                        "single-line": "",
                                                        readonly:
                                                          _vm.readonly ||
                                                          row.hours_readonly ===
                                                            "true" ||
                                                          !_vm.isCurrentDate(
                                                            row.date
                                                          )
                                                      },
                                                      model: {
                                                        value: row.hours,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row,
                                                            "hours",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression: "row.hours"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-right text-no-wrap"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.toNum(row.hours) *
                                                            _vm.toNum(
                                                              row.persons
                                                            )
                                                        ) +
                                                        "h "
                                                    )
                                                  ]
                                                ),
                                                !_vm.readonly
                                                  ? _c(
                                                      "td",
                                                      [
                                                        row.hours_readonly !==
                                                          "true" &&
                                                        _vm.isCurrentDate(
                                                          row.date
                                                        )
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  icon: "",
                                                                  small: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.articles[
                                                                      item._idx
                                                                    ].hours_grid.splice(
                                                                      ri,
                                                                      1
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "mdi-close"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "d-flex align-center mt-2" },
                          [
                            _vm.oldHoursGridCount(item._idx) > 0
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      "x-small": "",
                                      text: "",
                                      color: "grey"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$set(
                                          _vm.showOldGrid,
                                          item._idx,
                                          !_vm.showOldGrid[item._idx]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { "x-small": "", left: "" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.showOldGrid[item._idx]
                                                ? "mdi-eye"
                                                : "mdi-eye-off"
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.oldHoursGridCount(item._idx)
                                        ) +
                                        " alte "
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("v-spacer"),
                            !_vm.readonly
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      outlined: "",
                                      small: "",
                                      color: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addHoursRow(item)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { left: "", small: "" } },
                                      [_vm._v("mdi-plus")]
                                    ),
                                    _vm._v(" Stunden ")
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    : _vm._e(),
                  item.input_type === "article" && item.line_type !== "title"
                    ? [
                        _vm.articles[item._idx].articles_grid &&
                        _vm.articles[item._idx].articles_grid.length
                          ? _c(
                              "div",
                              { staticClass: "grid-scroll mt-2" },
                              [
                                _c("v-simple-table", { attrs: { dense: "" } }, [
                                  _c("thead", [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticStyle: { "min-width": "80px" }
                                        },
                                        [_vm._v("Menge")]
                                      ),
                                      !_vm.readonly
                                        ? _c("th", {
                                            staticStyle: { "min-width": "36px" }
                                          })
                                        : _vm._e()
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(
                                        _vm.articles[item._idx].articles_grid,
                                        function(row, ri) {
                                          return [
                                            !_vm.isCurrentDate(row.date) &&
                                            _vm.showOldGrid[item._idx] &&
                                            _vm.isFirstOfDate(
                                              _vm.articles[item._idx]
                                                .articles_grid,
                                              ri
                                            )
                                              ? _c(
                                                  "tr",
                                                  {
                                                    key: "ad" + ri,
                                                    staticClass: "old-entry"
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "caption font-weight-bold grey lighten-3 py-1",
                                                        attrs: {
                                                          colspan: _vm.readonly
                                                            ? 1
                                                            : 2
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                row.date
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "tr",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.isCurrentDate(
                                                        row.date
                                                      ) ||
                                                      _vm.showOldGrid[
                                                        item._idx
                                                      ],
                                                    expression:
                                                      "isCurrentDate(row.date) || showOldGrid[item._idx]"
                                                  }
                                                ],
                                                key: ri,
                                                class: {
                                                  "grey lighten-4":
                                                    row.article_readonly ===
                                                    "true",
                                                  "old-entry": !_vm.isCurrentDate(
                                                    row.date
                                                  )
                                                }
                                              },
                                              [
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        type: "number",
                                                        min: "0",
                                                        dense: "",
                                                        "hide-details": "",
                                                        "single-line": "",
                                                        readonly:
                                                          _vm.readonly ||
                                                          row.article_readonly ===
                                                            "true" ||
                                                          !_vm.isCurrentDate(
                                                            row.date
                                                          )
                                                      },
                                                      model: {
                                                        value: row.quantity,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row,
                                                            "quantity",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "row.quantity"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                !_vm.readonly
                                                  ? _c(
                                                      "td",
                                                      [
                                                        row.article_readonly !==
                                                          "true" &&
                                                        _vm.isCurrentDate(
                                                          row.date
                                                        )
                                                          ? _c(
                                                              "v-btn",
                                                              {
                                                                attrs: {
                                                                  icon: "",
                                                                  small: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    _vm.articles[
                                                                      item._idx
                                                                    ].articles_grid.splice(
                                                                      ri,
                                                                      1
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "mdi-close"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e()
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        }
                                      )
                                    ],
                                    2
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "d-flex align-center mt-2" },
                          [
                            _vm.oldArticlesGridCount(item._idx) > 0
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      "x-small": "",
                                      text: "",
                                      color: "grey"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$set(
                                          _vm.showOldGrid,
                                          item._idx,
                                          !_vm.showOldGrid[item._idx]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { "x-small": "", left: "" } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.showOldGrid[item._idx]
                                                ? "mdi-eye"
                                                : "mdi-eye-off"
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.oldArticlesGridCount(item._idx)
                                        ) +
                                        " alte "
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("v-spacer"),
                            !_vm.readonly
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      outlined: "",
                                      small: "",
                                      color: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addArticleRow(item)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { left: "", small: "" } },
                                      [_vm._v("mdi-plus")]
                                    ),
                                    _vm._v(" Menge ")
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              )
        ]
      }),
      _c("div", { staticClass: "subtitle-1 font-weight-bold mt-4 mb-2" }, [
        _vm._v(" Zusätzliche Arbeiten ")
      ]),
      _vm._l(_vm.additionalWorks, function(work, wi) {
        return _c(
          "v-card",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.isCurrentDate(work.date) || _vm.showOldAdditionalWorks,
                expression: "isCurrentDate(work.date) || showOldAdditionalWorks"
              }
            ],
            key: "aw" + wi,
            class: [
              "mb-2 pa-3",
              { "old-entry": !_vm.isCurrentDate(work.date) }
            ],
            attrs: { outlined: "" }
          },
          [
            _c("v-textarea", {
              staticClass: "mb-2",
              attrs: {
                label: "Beschreibung",
                readonly: _vm.readonly || !_vm.isCurrentDate(work.date),
                outlined: "",
                dense: "",
                rows: "2",
                "auto-grow": "",
                "hide-details": ""
              },
              model: {
                value: work.description,
                callback: function($$v) {
                  _vm.$set(work, "description", $$v)
                },
                expression: "work.description"
              }
            }),
            _c(
              "v-row",
              { attrs: { dense: "" } },
              [
                _c(
                  "v-col",
                  { attrs: { cols: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Pers.",
                        type: "number",
                        min: "1",
                        dense: "",
                        "hide-details": "",
                        outlined: "",
                        readonly: _vm.readonly || !_vm.isCurrentDate(work.date)
                      },
                      model: {
                        value: work.persons,
                        callback: function($$v) {
                          _vm.$set(work, "persons", _vm._n($$v))
                        },
                        expression: "work.persons"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { attrs: { cols: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Stunden",
                        type: "number",
                        step: "0.25",
                        min: "0",
                        dense: "",
                        "hide-details": "",
                        outlined: "",
                        readonly: _vm.readonly || !_vm.isCurrentDate(work.date)
                      },
                      model: {
                        value: work.hours,
                        callback: function($$v) {
                          _vm.$set(work, "hours", _vm._n($$v))
                        },
                        expression: "work.hours"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "d-flex align-center", attrs: { cols: "4" } },
                  [
                    _c("span", { staticClass: "caption grey--text" }, [
                      _vm._v(
                        " = " + _vm._s(_vm.additionalWorkTotal(work)) + "h "
                      )
                    ])
                  ]
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "d-flex align-center mt-1" },
              [
                _c("span", { staticClass: "caption grey--text" }, [
                  _vm._v(_vm._s(_vm.formatDate(work.date)))
                ]),
                _c("v-spacer"),
                !_vm.readonly && _vm.isCurrentDate(work.date)
                  ? _c(
                      "v-btn",
                      {
                        attrs: { icon: "", "x-small": "" },
                        on: {
                          click: function($event) {
                            return _vm.additionalWorks.splice(wi, 1)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("mdi-close")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      }),
      _vm.additionalWorks.length && _vm.currentDayAdditionalWorkHours > 0
        ? _c(
            "div",
            { staticClass: "d-flex caption font-weight-bold mb-1 px-2" },
            [
              _c("span", [
                _vm._v(
                  "Summe Zusätzliche Arbeiten: " +
                    _vm._s(_vm.currentDayAdditionalWorkHours) +
                    "h"
                )
              ])
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _vm.oldAdditionalWorksCount > 0
            ? _c(
                "v-btn",
                {
                  attrs: { "x-small": "", text: "", color: "grey" },
                  on: {
                    click: function($event) {
                      _vm.showOldAdditionalWorks = !_vm.showOldAdditionalWorks
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { "x-small": "", left: "" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.showOldAdditionalWorks ? "mdi-eye" : "mdi-eye-off"
                        ) +
                        " "
                    )
                  ]),
                  _vm._v(" " + _vm._s(_vm.oldAdditionalWorksCount) + " alte ")
                ],
                1
              )
            : _vm._e(),
          _c("v-spacer"),
          !_vm.readonly
            ? _c(
                "v-btn",
                {
                  attrs: { outlined: "", small: "", color: "primary" },
                  on: { click: _vm.addAdditionalWork }
                },
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-plus")
                  ]),
                  _vm._v(" Zusätzliche Arbeit ")
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-4", attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-textarea", {
                attrs: {
                  label: "Interne Bemerkung",
                  readonly: _vm.readonly,
                  outlined: "",
                  dense: "",
                  rows: "2",
                  "auto-grow": ""
                },
                model: {
                  value: _vm.values.internal_comment,
                  callback: function($$v) {
                    _vm.$set(_vm.values, "internal_comment", $$v)
                  },
                  expression: "values.internal_comment"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("div", { ref: "barSentinel" }),
      _c(
        "v-alert",
        {
          ref: "comparisonBar",
          class: ["mt-4 mb-0", { "comparison-bar--fixed": _vm.isBarFixed }],
          attrs: {
            color: _vm.hoursDiff === 0 ? "success" : "warning",
            dense: ""
          }
        },
        [
          _c("div", { staticClass: "d-flex flex-wrap align-center" }, [
            _c("span", { staticClass: "mr-4 font-weight-medium" }, [
              _vm._v(_vm._s(_vm.formattedSelectedDate))
            ]),
            _c("span", { staticClass: "mr-4" }, [
              _vm._v(" Netto-Arbeit: "),
              _c("strong", [_vm._v(_vm._s(_vm.netWorkHours) + "h")])
            ]),
            _c("span", { staticClass: "mr-4" }, [
              _vm._v(" Zugeordnet: "),
              _c("strong", [_vm._v(_vm._s(_vm.totalAllocatedHours) + "h")])
            ]),
            _c(
              "span",
              {
                class:
                  _vm.hoursDiff !== 0
                    ? "red--text font-weight-bold"
                    : "green--text"
              },
              [_vm._v(" Offen: " + _vm._s(_vm.hoursDiff) + "h ")]
            )
          ])
        ]
      ),
      _c(
        "v-bottom-sheet",
        {
          attrs: { scrollable: "" },
          model: {
            value: _vm.descriptionDialog,
            callback: function($$v) {
              _vm.descriptionDialog = $$v
            },
            expression: "descriptionDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                {
                  staticClass: "pt-4",
                  staticStyle: {
                    "white-space": "pre-line",
                    "max-height": "60vh",
                    "overflow-y": "auto"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.descriptionText) + " ")]
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function($event) {
                          _vm.descriptionDialog = false
                        }
                      }
                    },
                    [_vm._v(" Schliessen ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }